import React from 'react'
import { Container, Icon64 } from '@pmi/pmi-iqos-ds-react'
import { goTo, Routes } from '@pmi/pmi-iqos-shared-react'

const CartIcon64 = ({ hasItems }) => {
  return (
    <Container
      onClickHandler={() => goTo(Routes.cart, true)}
      display={Container.displays.inlineBlock}
      position={Container.positions.relative}>
      <Icon64 size={Icon64.sizes.m} image={Icon64.images.cart} />
      {hasItems ? (
        <Container
          position={Container.positions.absolute}
          bg={Container.backgrounds.turquoise}
          rounded={Container.roundedSizes.full}
          height="3"
          width="3"
          r="0"
          b="0"
        />
      ) : null}
    </Container>
  )
}

export default CartIcon64
